import {Component, ViewChild, ViewEncapsulation} from '@angular/core';

import {GuideService} from '../../services/guide.service';
import {SpotListComponent} from '../spot-list/spot-list.component';
import {MatSidenav} from '@angular/material';

@Component({
  selector: 'app',
  templateUrl: './app.component.html',
  styleUrls: [
    '../../../../node_modules/font-awesome/css/font-awesome.css',
    '../../../../node_modules/material-design-icons/iconfont/material-icons.css',
    '../../../assets/css/material.css',
    './app.component.less',
    './app.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  providers: []
})
export class AppComponent {

  title = '';
  logo = '';

  @ViewChild('sidenav') sidenav:MatSidenav;

  @ViewChild('spotlist')
  spotlist: SpotListComponent;

  constructor(private guideService: GuideService) {
    this.guideService.getActiveGuide().then(guide => {
      this.title = guide.title;
      this.logo = 'assets/guides/' + guide._id + '/images/logo.png';
      this.spotlist.setSideNav(this.sidenav);
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/muth/Documents/privat/angular/guidr/src/app/components/app/app.component.ts